import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

// axios config
Axios.defaults.baseURL = "https://idebackend.dhwajgupta.in/";
Axios.defaults.headers.common.Authorization = ``;
Axios.defaults.headers.post["Content-Type"] = "application/json";

// render
ReactDOM.render(
  <React.StrictMode>
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover={false}
    />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
